import {
    GET_RECONCILIATION_REPORT_SUCCESS,
    GET_RECONCILIATION_REPORT_PENDING,
    GET_RECONCILIATION_TRANSACTION_DETAILS_PENDING,
    GET_RECONCILIATION_TRANSACTION_DETAILS_SUCCESS,
    GET_RECONCILIATION_TRANSACTION_DETAILS_FAILURE,
    GET_CARRIER_PROFIT_PENDING,
    GET_CARRIER_PROFIT_SUCCESS
} from '../actions/carrierReconciliationReport.action';

const initialState = {
    reconciliationReport: {},
    reconciliationReportStatus: '',
    reconciliationTransactionDetails: [],
    reconciliationTransactionDetailsStatus: 'idle',
    loader: false,
    error: null,
    pnlReportListing: {},
    pnlReportListingStatus: ''
};

/* istanbul ignore next */
const carrierReconciliationReportReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_RECONCILIATION_REPORT_SUCCESS:
            return {
                ...state,
                reconciliationReport: action.payload,
                reconciliationReportStatus: 'SUCCESS',
                loading: false,
                error: null
            };
        case GET_RECONCILIATION_REPORT_PENDING:
            return {
                ...state,
                reconciliationReport: {},
                reconciliationReportStatus: 'PENDING',
                loading: true,
                error: null
            };
        case GET_RECONCILIATION_TRANSACTION_DETAILS_PENDING:
            return {
                ...state,
                reconciliationTransactionDetails: [],
                reconciliationTransactionDetailsStatus: 'pending',
                loading: true,
                error: null
            };
        case GET_RECONCILIATION_TRANSACTION_DETAILS_SUCCESS:
            return {
                ...state,
                reconciliationTransactionDetails: action.payload.data || [],
                reconciliationTransactionDetailsStatus: 'success',
                loading: false,
                error: null
            };
        case GET_RECONCILIATION_TRANSACTION_DETAILS_FAILURE:
            return {
                ...state,
                reconciliationTransactionDetails: [],
                reconciliationTransactionDetailsStatus: 'failure',
                loading: false,
                error: action.payload
            };
        case GET_CARRIER_PROFIT_PENDING:
            return {
                ...state,
                pnlReportListing: {},
                pnlReportListingStatus: 'PENDING',
            };
        case GET_CARRIER_PROFIT_SUCCESS:
            return {
                ...state,
                pnlReportListing: action.payload,
                pnlReportListingStatus: 'SUCCESS',
            };
        default:
            return state;
    }
};

export default carrierReconciliationReportReducer;